export default __webpack_public_path__ + "static/media/RomasSignature.51234a2a.jpg";